// #region imports

// --- HS Code
import { JournalEntryModel } from './journal-entry-model';

// #endregion

export interface GroupJournalEntryModel {
  styleId: number | string;
  resourceKey: string;
  pinnedJournalEntries: JournalEntryModel[];
  unpinnedJournalEntries: JournalEntryModel[];
}
